import React from 'react';
import styled from 'styled-components';
import { PaperProps, Paper } from '@material-ui/core';

export const ToolbarPaper = styled(({ square, ...other }: PaperProps) => <Paper square {...other} />)`
    ${({ theme }) => `
        && {
            background-color: ${theme.palette.common.white};
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
        }
    `}
`;